import axios from "axios";
import { WalletDetailsResponse } from "redmond";
import { config } from "../../config";
import { travelWalletApiPrefix } from "../paths";

const END_POINT: string = `${travelWalletApiPrefix}/details`;

export const fetchTravelWalletDetails =
  async (): Promise<WalletDetailsResponse> => {
    const res = await axios.get(END_POINT, {
      baseURL: config.baseURL,
    });
    return res.data;
  };
